var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilegray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 11.5C18.6875 10.7541 18.3912 10.0387 17.8637 9.51126C17.3363 8.98382 16.6209 8.6875 15.875 8.6875C15.1291 8.6875 14.4137 8.98382 13.8863 9.51126C13.3588 10.0387 13.0625 10.7541 13.0625 11.5C13.0625 12.2459 13.3588 12.9613 13.8863 13.4887C14.4137 14.0162 15.1291 14.3125 15.875 14.3125C16.6209 14.3125 17.3363 14.0162 17.8637 13.4887C18.3912 12.9613 18.6875 12.2459 18.6875 11.5ZM11.375 11.5C11.375 10.3065 11.8491 9.16193 12.693 8.31802C13.5369 7.47411 14.6815 7 15.875 7C17.0685 7 18.2131 7.47411 19.057 8.31802C19.9009 9.16193 20.375 10.3065 20.375 11.5C20.375 12.6935 19.9009 13.8381 19.057 14.682C18.2131 15.5259 17.0685 16 15.875 16C14.6815 16 13.5369 15.5259 12.693 14.682C11.8491 13.8381 11.375 12.6935 11.375 11.5ZM9.7332 23.3125H22.0168C21.7039 21.0871 19.7914 19.375 17.4816 19.375H14.2684C11.9586 19.375 10.0461 21.0871 9.7332 23.3125ZM8 23.9559C8 20.493 10.8055 17.6875 14.2684 17.6875H17.4816C20.9445 17.6875 23.75 20.493 23.75 23.9559C23.75 24.5324 23.2824 25 22.7059 25H9.04414C8.46758 25 8 24.5324 8 23.9559Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilegray);
export default __webpack_public_path__ + "static/media/profilegray.9ebca5c797ab0deff6cff333cecdaa99.svg";
export { ForwardRef as ReactComponent };